import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domClass from 'dojo/dom-class';

import _WidgetBaseSP from 'more/_WidgetBaseSP';

import template from './MaintenanceTaskFilters.html?raw';

class MaintenanceTaskFilters extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    list: any = null;
    employee: any = null;
    filtermode = "editor";
    sorting = "date_desc";
    searchKey = "";
    _request: any = null;
    _filterParams: any = null;

    _startupState = "new";
    _startupSteps: any = [];
    _startupStepsDone: any = [];

    isExternalEmployee = false;

    startup(employeeEntity?: any): void {
        //console.log("filters startup", employeeEntity);
        if (typeof (employeeEntity) == "undefined") {
            // erstmal prüfen wer ich bin, damit wir wissen ob das Filterpanel irgendwie reagieren muss (Bearbeiter vs. Melder)
            this._getCurrentEmployee();
        } else {
            this.employee = employeeEntity;
            this.loadOptions();
        }
        this.setFilterVisibility();
        //this.loadOptions();
    }

    _setFiltermodeAttr(value: any): void {
        this.filtermode = value;
        //console.debug("filtermode set to " + value, this._startupState);
        this.setFilterVisibility();

        if (this._startupState == "ready") {
            this._lastRequestParameters = null;
            this.applyFilters(0);
        }
    }

    _setSortingAttr(value: any): void {
        //console.log("filter: new sorting", this.sorting, "new:", value);

        if (this.sorting != value) {
            this.sorting = value;

            this.applyFilters();
        }
    }

    _setSearchKeyAttr(value: any): void {
        if (value == this.searchKey) {
            return;
        }

        this.searchKey = value;

        if (this._searchTimeout != null) {
            clearTimeout(this._searchTimeout);
            this._searchTimeout = null;
        }

        this._searchTimeout = setTimeout(lang.hitch(this, "applyFilters"), 888);
    }

    setFilterVisibility(): void {

        domClass.add(this.groupStatus, "w3-hide");
        domClass.add(this.groupBuilding, "w3-hide");
        domClass.add(this.containerLimitToLocation, "w3-hide");


        var bShowLimitToLocation = false;

        if (this.employee != null) {
            if (this.employee.ref_last_location != null) {
                bShowLimitToLocation = true;
            }
        }

        switch (this.filtermode) {
            case "editor":
            default:
                domClass.remove(this.groupStatus, "w3-hide");
                domClass.remove(this.groupBuilding, "w3-hide");
                (window as any).bShowEmployeGroups = false;
                break;
        }

        if (bShowLimitToLocation === true) {
            domClass.remove(this.containerLimitToLocation, "w3-hide");
        } else {
            domClass.add(this.containerLimitToLocation, "w3-hide");
        }

        if (this._startupState != "ready") {
            //this.inputLimitToLocation.checked = "checked";
        }
    }

    _getFilterSettings(presetName?: any): void {
        //LoadFilterSettings(string filterMode, string presetName) ...

        var url = window.appRoot + "JDM/Maintenance_LoadFilterSettings";

        this._request = this.RequestManager.post(
            url,
            {
                "presetName": presetName,
                "filterMode": this.filtermode//"editor",
            },
            lang.hitch(this, "_onGetFilterSettingsResponse"),
            lang.hitch(this, "_onGetFilterSettingsError"),
            false // sync
        );
    }

    _onGetFilterSettingsResponse(response: any): void {
        //console.log("_onGetFilterSettingsResponse", response);

        if (typeof (response) == "object" && response != null) {

            if (typeof (response.limitToRealEstate) != "undefined") {
                this.inputLimitToLocation.checked = response.limitToRealEstate == true;
            }

            if (typeof (response.buildings) != "undefined") {
                //this.inputMultiBuilding.set("value", response.buildings);
                this._reloadBuildingList(response.buildings);
            } else {
                this._reloadBuildingList(true);
            }

            if (typeof (response.statusList) != "undefined") {
                this._reloadStatusList(response.statusList);
            } else {
                this._reloadStatusList(true);
            }

            if (response.includeVehicles === true || response.includeVehicles === false) {
                this.inputShowVehicleTasks.checked = response.includeVehicles === true;// ? "checked" : "";
                this.pushStep("vehicles");
            }

        } else {
            this._onGetFilterSettingsError("no error, just empty settings");
        }

        this.pushStep("filterpreset");
        this.pushStep("limitToMyExecutions");
    }

    _onGetFilterSettingsError(error: any): void {
        console.warn("_onGetFilterSettingsError?", error);
        this._reloadBuildingList(true);
        this._reloadStatusList(true);
        this.pushStep("filterpreset");
        this.pushStep("limitToMyExecutions");
    }

    loadOptions(): void {

        if (this.employee != null) {
            this.isExternalEmployee = this.employee.Classname == "Contact_person";
        }

        // Filterwerte vorladen!
        this._getFilterSettings();

        this._startupSteps = [];
        //console.log("filter load options", this.filtermode);
        this._startupState = "loading";
        switch (this.filtermode) {
            case "editor":
            default:
                this._startupSteps = ["status", "building", "employeeLocation", "filterpreset", "vehicles"];

                if (this.employee != null) {
                    this.set("employee", this.employee);
                }
                //this._reloadBuildingList(null);

                break;


        }
        this.setFilterVisibility();
    }

    pushStep(name: any): void {

        if (this._startupStepsDone.indexOf(name) == -1) {
            this._startupStepsDone.push(name);
        }

        //console.debug("filter push step: " + name,  "needed/done:", this._startupSteps, this._startupStepsDone, this._startupState);

        for (var i = 0; i < this._startupSteps.length; i++) {
            var key = this._startupSteps[i];

            if (this._startupStepsDone.indexOf(key) == -1) {
                //console.debug("filter: abort - not all steps done");
                return;
            }
        }

        if (this._startupStepsDone.length < this._startupSteps.length) {
            //console.debug("filter: abort - not all steps done (check2)");
            return;
        }

        if (this._startupSteps.length == 0) {
            //console.debug("filter: abort - no steps defined");
            return;
        }

        this.StandbyStop();
        this.applyFilters(0);
    }

    removeStep(): void {

    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._startupStepsDone = [];
    }



    _getCurrentEmployee(): void {
        var employee = null;

        try {
            var employeeTXT = sessionStorage.getItem("currentEmployee");
            employee = JSON.parse(employeeTXT);
        } catch (ex) {
            employee = null;
        }

        if (employee != null) {
            this._onGetCurrentEmployeeResponse(employee);
            return;
        }
        this.StandbyStart();
        var url = window.appRoot + "JDM/GetCurrentEmployeeJSON";

        this.RequestManager.post(
            url,
            {
            },
            lang.hitch(this, "_onGetCurrentEmployeeResponse"),
            lang.hitch(this, function (error) {
                console.error("current employee fehler", error.message);
            }),
            false // sync
        );
    }

    _onGetCurrentEmployeeResponse(response: any): void {
        //console.debug("filter employee loaded", response);
        sessionStorage.setItem("currentEmployee", JSON.stringify(response));

        this.set("employee", response);
    }

    _setEmployeeAttr(entity: any, bSuppressReload?: any): void {
        var bActivateAllBuildings = false;
        if (this.employee) {
            if (this.employee.ref_last_location != entity.ref_last_location) {
                if (this.inputLimitToLocation.checked == true) {
                    bActivateAllBuildings = true;
                }
            }
        }
        this.employee = entity;
        //console.debug("filter employee set", this._startupState, entity );

        if (this._startupState == "new") {
            this.loadOptions();
            return;
        } else if (this._startupState == "ready") {

            if (bActivateAllBuildings == true) {
                this._reloadBuildingList(null);
            } else {
                this._reloadBuildingList(this.inputBuilding.get("value"));
            }
        }
        else {
            this.StandbyStop();
        }
    }


    _onChangeInput_Status(selectedValue: any): void {

        //console.debug("_onChangeInput_Status", selectedValue);
        this.pushStep("status");
        //this.applyFilters();

    }

    _onChangeLimitToMyExecutions(selectedValue: any): void {

        //console.debug("_onChangeBuilding", selectedValue);
        this.pushStep("containerLimitToMyExecutions");
        //this.applyFilters();

    }

    _onChangeVehicleTasks(evt: any): void {
        this.pushStep("vehicles");
    }

    _onChangeInput_Building(value: any): void {
        //console.debug("_onChangeBuildingMulti", value);
        this.pushStep("building");
    }


    _onChangeEmployeegroupMulti(selectedValue: any): void {

        //console.debug("_onChangeEmployeegroupMulti", selectedValue);
        this.pushStep("employeeGroup");
    }
    _onChangeMaintypeMulti(selectedValue: any): void {

        //console.debug("_onChangeMaintypeMulti", selectedValue);
        this.pushStep("maintype");
    }

    _onChangeLimitToLocation(evt: any): void {
        //var newPreset = this.inputLimitToLocation.checked == true ?
        this._reloadBuildingList(this.inputBuilding.get("value"));
    }

    _reloadStatusList(presetStatuslist: any): void {
        if (presetStatuslist) {
            if (presetStatuslist.length == 0) {
                presetStatuslist = true; // ALLES selektieren
            }
        }
        this.inputStatus._loadListValues(presetStatuslist);
    }

    _reloadBuildingList(presetBuildings?: any): void {

        var jsonData: any = {};

        if (this.employee == null) {
            jsonData = { "limitToRealEstate": false };
        }
        else {
            jsonData = {
                "limitToRealEstate": this.inputLimitToLocation.checked == true, "employee": { "ID": this.employee.ID }
            };
        }
        //console.log("reload Buildinglist", jsonData, this._startupStepsDone);

        var label = this.translations["General_DropdownBlank_All_FromX"];
        if (jsonData.limitToRealEstate != true) {
            label = this.translations["General_DropdownBlank_All"];
        }
        //this.inputBuilding.setRequestParameter("jsonData", JSON.stringify(jsonData));
        //this.inputBuilding.set("blankOption", true, null, label.format(this.employee.ref_last_location.tmp_label));
        //this.inputBuilding._loadListValues(presetBuilding);

        if (presetBuildings) {
            if (presetBuildings.length == 0) {
                presetBuildings = true; // ALLES selektieren
            }
        }
        if (typeof (presetBuildings) == "undefined" || presetBuildings == null) {
            presetBuildings = true;
            console.info("no buildings selected - will select all");
        }


        this.inputBuilding.setRequestParameter("jsonData", JSON.stringify(jsonData));
        this.inputBuilding._loadListValues(presetBuildings);
    }

    _getSerializedFilterParams(): any {
        return {
            statusList: this.inputStatus.get("value"),
            buildings: this.inputBuilding.get("value"),
            limitToRealEstate: this.inputLimitToLocation.checked == true,
            includeVehicles: this.inputShowVehicleTasks.checked == true
        };
    }

    applyFilters(offset?: any): void {
        //console.log("apply filters", this._startupState, offset);

        this._startupState = "ready";
        //this.StandbyStart();

        var countLimit = 50;
        if (typeof (offset) != "number") {
            offset = 0;
        }

        // Filterparameter in Objekt zusammenstellen
        var valueSorting = this.sorting;

        var filterParams = this._getSerializedFilterParams();

        filterParams._countLimit = countLimit;
        filterParams._offset = offset;
        filterParams.sorting = valueSorting;
        filterParams.searchKey = this.searchKey;

        var nextOffset = offset + countLimit;

        var stringParams = JSON.stringify(filterParams);

        (this as any).emit("newFiltersettings", stringParams, this.filtermode, offset, nextOffset);
    }
}
MaintenanceTaskFilters.prototype.declaredClass = 'WidgetCollection.Maintenance.MaintenanceTaskFilters';

export default mdsWidget(MaintenanceTaskFilters);
